export default "__VITE_ASSET__726fece9__"